/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { BaiConfigurationModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class BaiconfigurationClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags BaiConfiguration
   * @name BaiConfigurationGetBaiConfiguration
   * @summary Returns BAI configurations.
   * @request GET:/baiconfiguration
   */
  baiConfigurationGetBaiConfiguration = (params: RequestParams = {}) =>
    this.http.request<BaiConfigurationModelDto, any>({
      path: `/baiconfiguration`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BaiConfiguration
   * @name BaiConfigurationSaveBaiConfiguration
   * @summary Save configurations related to BAI.
   * @request POST:/baiconfiguration
   */
  baiConfigurationSaveBaiConfiguration = (
    data: BaiConfigurationModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<BaiConfigurationModelDto, any>({
      path: `/baiconfiguration`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
